import { DEFAULT_OPTS } from "./api.js";
function* white(opts) {
  const { scale, rnd } = { ...DEFAULT_OPTS, ...opts };
  while (true) {
    yield rnd.norm(scale);
  }
}
export {
  white
};
